// All needed imports
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { ConsoleUtils } from './app/core/init/console.utils';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

// check if the environment is production
if (environment.production) {
  enableProdMode();
  ConsoleUtils.overrideAlertMethods();
  ConsoleUtils.overrideConsoleMethods();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
